import { ChangeEvent, useEffect, useState } from "react";

import styled from "@emotion/styled";

interface SearchInputProps {
  delay?: number;
  initialValue?: string;
  onChange: (value: string) => void;
}

const StyledInput = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  width: 100%;
  max-width: 600px;
  box-sizing: border-box;
  text-transform: uppercase;

  &:focus {
    border-color: darkgray;
  }
`;

export const SearchInput: React.FC<SearchInputProps> = ({ delay, initialValue, onChange }) => {
  delay ??= 300;
  const [value, setValue] = useState<string>(initialValue || "");
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const timeout = setTimeout(() => {
      onChange(newValue);
    }, delay);

    setDebounceTimeout(timeout);
  };

  useEffect(() => {
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

  return <StyledInput type="text" value={value} onChange={handleChange} placeholder="Search..." />;
};
